<template>
  <div class="companySet">
    <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
      <el-radio-button label="1">短信配置</el-radio-button>
      <el-radio-button label="2">推送配置</el-radio-button>
      <el-radio-button label="3">公众号配置</el-radio-button>
      <el-radio-button label="4">小程序配置</el-radio-button>
    </el-radio-group>
    <!-- 短信配置 -->
    <el-card v-show="tabPosition == 1" class="my_card1" shadow="never">
      <!-- 主页 -->
      <div
        v-if="
          $route.query.target != 2 &&
          $route.query.target != 3 &&
          $route.query.target != 4 &&
          $route.query.target != 5
        "
      >
        <div class="title">
          <p>
            <img src="../../assets/images/ticons/Slice 18@2x.png" alt="" />
            <span>阿里云短信</span>
          </p>
          <p>
            <el-button
              class="refresh"
              plain
              round
              icon="el-icon-refresh-right"
              @click="refresh"
              >刷新列表</el-button
            >
            <el-button
              @click="
                value = true;
                type = 1;
              "
              class="addbtn"
              type="primary"
              round
              icon="el-icon-plus"
              >创建账号</el-button
            >
          </p>
        </div>
        <el-table
          :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column prop="d1" label="账号名称" width="180">
          </el-table-column>
          <el-table-column prop="d2" label="创建人" width="180">
          </el-table-column>
          <el-table-column prop="d3" label="创建时间" width="280">
          </el-table-column>
          <el-table-column prop="d4" label="操作">
            <template slot-scope="scope">
              <el-switch :width="30" v-model="scope.row.d4"> </el-switch>
              <el-button
                class="minibtn"
                @click="scope.row.d4 = !scope.row.d4"
                type="text"
                size="mini"
                >{{ scope.row.d4 ? "停用" : "启用" }}</el-button
              >
              <el-button
                @click="ontestsend(scope.row)"
                class="minibtn"
                type="text"
                size="mini"
                >测试发送</el-button
              >
              <el-button
                @click="$router.push('/systemSetup/messageTemplate')"
                class="minibtn"
                type="text"
                size="mini"
                >短信模版</el-button
              >
              <el-button
                @click="$router.push('/systemSetup/messageSignatures')"
                class="minibtn"
                type="text"
                size="mini"
                >短信签名</el-button
              >
              <el-button
                class="minibtn"
                type="text"
                size="mini"
                @click="
                  value = true;
                  type = 1.5;
                "
                >编辑</el-button
              >
              <el-button
                class="minibtn"
                type="text"
                size="mini"
                @click="remove1"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 短信模板模板详情页 -->
      <div class="templateDetails" v-if="$route.query.target == 2">
        <h3>模板详情</h3>
        <div class="d1">
          <p class="p1">
            <span class="s1">模版名称：</span
            ><span class="s2">发货通知收货人</span>
          </p>
          <p class="p2">
            <span class="s1">模版code：</span
            ><span class="s2">SMS1232133321</span>
          </p>
          <p class="p3">
            <span class="s1">模版内容：</span
            ><span class="s2"
              >尊敬的${name}，运单${order_code}已发货，请近几天保持电话畅通，以便配送人员联系，祝您生活愉快。</span
            >
          </p>
          <p class="p4">
            <span class="s1">申请说明：</span
            ><span class="s2"
              >这里是申请说明，这里是申请说明，这里是申请说明，这</span
            >
          </p>
        </div>
        <el-button
          class="back"
          plain
          round
          @click="$router.push('/systemSetup/messageTemplate')"
          >返回</el-button
        >
      </div>
      <!-- 短信模板新增模板 -->
      <div class="addTemplate" v-if="$route.query.target == 3">
        <h3>新增模版-通知类型</h3>
        <!-- 表单区 -->
        <el-form :rules="rules" :model="form">
          <el-form-item
            class="itemend"
            label="模版名称："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-input
              placeholder="请输入7-8个文字或字母"
              v-model="form.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="模版内容："
            :label-width="formLabelWidth"
            prop="name2"
          >
            <el-input
              type="textarea"
              resize="none"
              placeholder="${变量名}"
              v-model="form.name2"
              autocomplete="off"
            ></el-input>
            <el-button @click="add" icon="el-icon-plus" type="primary" round
              >插入变量</el-button
            >
            <p class="text1">
              0-500字，70个字/条，超出70字时按67字/条计费教育、医疗、酒类、引导加微信短信容易被运营商屏蔽…
            </p>
            <p class="text2">了解更多屏蔽规则</p>
          </el-form-item>
          <el-form-item
            label="申请说明："
            :label-width="formLabelWidth"
            prop="name3"
          >
            <el-input
              type="textarea"
              resize="none"
              placeholder="请输入短信模版申请理由"
              v-model="form.name3"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="模板类型："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-radio-group v-model="form.radio">
              <el-radio label="通知类"></el-radio>
              <el-radio label="推广类"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="btn">
          <el-button
            plain
            round
            @click="$router.push('/systemSetup/messageTemplate')"
            >取消</el-button
          >
          <el-button type="primary" round @click="onAddTempYes">提交</el-button>
        </div>
      </div>
      <!-- 短信签名详情页 -->
      <div class="signatureDetails" v-if="$route.query.target == 4">
        <h3>签名详情</h3>
        <div class="d1">
          <p class="p1">
            <span class="s1">模版名称：</span><span class="s2">GYMOO</span>
          </p>
          <p class="p2">
            <span class="s1">签名用途：</span
            ><span class="s2">自有产品/非自有产品</span>
          </p>
          <p class="p3">
            <span class="s1">营业执照：</span
            ><span class="s2" @click="showViewer = true">点击查看 </span>
            <el-image-viewer
              v-show="showViewer"
              :url-list="imgList"
              :on-close="() => {showViewer = false;}"/>
          </p>
          <p class="p4">
            <span class="s1">营业执照有效期：</span
            ><span class="s2">长期有效/2010-10-10 ～ 2021-10-10</span>
          </p>
          <p class="p5">
            <span class="s1">其他证明文件：</span
            ><span class="s2" @click="showViewer = true">点击查看</span>
          </p>
          <p class="p6">
            <span class="s1">备注信息：</span
            ><span class="s2"
              >Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
              euismod bibendum laoreet. Proin gravida dolor sit amet lacus
              accumsan et viverra justo commodo. Proin sodales pulvinar sic
              tempor. Sociis natoque penatibus et magnis dis parturient montes,
              nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra
              vulputate, felis tellus mollis orci, sed rhoncus pronin sapien
              nunc accuan eget.</span
            >
          </p>
        </div>
        <el-button
          class="back"
          plain
          round
          @click="$router.push('/systemSetup/messageSignatures')"
          >返回</el-button
        >
      </div>
      <!-- 短信签名新增签名 -->
      <div class="addSignature" v-if="$route.query.target == 5">
        <h3>短信签名</h3>
        <p class="p">
          <span class="el-icon-warning-outline s1"></span>
          <span class="s2"
            >短信签名用于阿里云申请，审核通过后即可新建短信模块。
            <span style="color: #0c64bcff"> 操作指引>></span></span
          >
        </p>
        <!-- 表单区 -->
        <el-form :rules="rules" :model="form">
          <!-- 1 -->
          <el-form-item
            class="itemend"
            label="签名名称："
            :label-width="formLabelWidth"
            prop="name4"
          >
            <el-input
              placeholder="2～8个汉字，数字或字母"
              v-model="form.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- 2 -->
          <el-form-item
            label="签名用途："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-radio-group v-model="form.radio">
              <el-radio label="自有产品"></el-radio>
              <el-radio label="非自有产品"></el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 3 -->
          <el-form-item
            label="营业执照："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="tips">
              <span>*</span>请按尺寸上传 jpg/png 格式且小于2M的图片
            </p>
          </el-form-item>
          <!-- 4 -->
          <el-form-item
            label="营业执照有效期："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-radio-group v-model="form.radio">
              <el-radio label="选择日期"></el-radio>
              <el-radio label="长期有效"></el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 日期组件 -->
          <el-date-picker
           v-if="form.radio != '长期有效'"
            v-model="value1"
            type="daterange"
            range-separator="→"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <!-- 5 -->
          <el-form-item
            label="其他证件文件："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2"
              :before-upload="beforeAvatarUpload2"
            >
              <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="tips">
              <span>*</span>请按尺寸上传 jpg/png 格式且小于2M的图片
            </p>
          </el-form-item>
          <!-- 6 -->
          <el-form-item label="备注信息：" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              resize="none"
              placeholder="请描述短息签名使用场景，以便快速通过审核"
              v-model="form.name2"
              autocomplete="off"
              style="width: 422px; height: 89px"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="btn">
          <el-button
            plain
            round
            @click="$router.push('/systemSetup/messageSignatures')"
            >取消</el-button
          >
          <el-button type="primary" round @click="onAddTempYes"
            >立即新建</el-button
          >
        </div>
      </div>
    </el-card>
    <!-- 推送配置 1-->
    <el-card
      v-show="tabPosition == 2"
      class="my_card2"
      shadow="never"
      style="height: 300px"
    >
      <div class="title">
        <p>
          <img src="../../assets/images/ticons/Slice 18@2x (1).png" alt="" />
          <span>极光推送</span>
        </p>
        <p>
          <el-button
            class="refresh"
            plain
            round
            icon="el-icon-refresh-right"
            @click="refresh"
            >刷新列表</el-button
          >
          <el-button
            @click="
              value = true;
              type = 2;
            "
            class="addbtn"
            type="primary"
            round
            icon="el-icon-plus"
            >创建账号</el-button
          >
        </p>
      </div>
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData2"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="账号名称" width="180">
        </el-table-column>
        <el-table-column prop="d2" label="创建人" width="180">
        </el-table-column>
        <el-table-column prop="d3" label="创建时间" width="480">
        </el-table-column>
        <el-table-column prop="d4" label="操作">
          <template slot-scope="scope">
            <el-switch :width="30" v-model="scope.row.d4"> </el-switch>
            <el-button
              class="minibtn"
              @click="scope.row.d4 = !scope.row.d4"
              type="text"
              size="mini"
              >{{ scope.row.d4 ? "停用" : "启用" }}</el-button
            >
            <el-button
              class="minibtn"
              type="text"
              size="mini"
              @click="
                value = true;
                type = 1.5;
              "
              >编辑</el-button
            >
            <el-button class="minibtn" type="text" size="mini" @click="remove1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 推送配置 2-->
    <el-card
      v-show="tabPosition == 2"
      class="my_card2"
      shadow="never"
      style="margin-top: 20px; height: 500px"
    >
      <div class="title">
        <p>
          <img src="../../assets/images/ticons/Slice 18@2x (2).png" alt="" />
          <span>友盟推送</span>
        </p>
        <p>
          <el-button
            class="refresh"
            plain
            round
            icon="el-icon-refresh-right"
            @click="refresh"
            >刷新列表</el-button
          >
          <el-button
            @click="
              value = true;
              type = 2;
            "
            class="addbtn"
            type="primary"
            round
            icon="el-icon-plus"
            >创建账号</el-button
          >
        </p>
      </div>
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData2d5"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="账号名称" width="180">
        </el-table-column>
        <el-table-column prop="d2" label="创建人" width="180">
        </el-table-column>
        <el-table-column prop="d3" label="创建时间" width="480">
        </el-table-column>
        <el-table-column prop="d4" label="操作">
          <template slot-scope="scope">
            <el-switch :width="30" v-model="scope.row.d4"> </el-switch>
            <el-button
              class="minibtn"
              @click="scope.row.d4 = !scope.row.d4"
              type="text"
              size="mini"
              >{{ scope.row.d4 ? "停用" : "启用" }}</el-button
            >
            <el-button
              class="minibtn"
              type="text"
              size="mini"
              @click="
                value = true;
                type = 1.5;
              "
              >编辑</el-button
            >
            <el-button class="minibtn" type="text" size="mini" @click="remove1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 公众号配置 -->
    <el-card v-show="tabPosition == 3" class="my_card3" shadow="never">
      <div class="title">
        <p>
          <img src="../../assets/images/ticons/Slice 14@2x.png" alt="" />
          <span>公众号配置</span>
        </p>
        <p>
          <el-button
            class="refresh"
            plain
            round
            icon="el-icon-refresh-right"
            @click="refresh"
            >刷新列表</el-button
          >
          <el-button
            @click="
              value = true;
              type = 2;
            "
            class="addbtn"
            type="primary"
            round
            icon="el-icon-plus"
            >创建账号</el-button
          >
        </p>
      </div>
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData3"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="账号名称" width="180">
        </el-table-column>
        <el-table-column prop="d2" label="类型" width="180">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.d2 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="d3" label="APPID" width="180"> </el-table-column>
        <el-table-column prop="t4" label="创建人" width="180">
        </el-table-column>
        <el-table-column prop="d5" label="创建时间" width="180">
        </el-table-column>
        <el-table-column prop="d6" label="操作">
          <template slot-scope="scope">
            <el-switch :width="30" v-model="scope.row.d6"> </el-switch>
            <el-button
              class="minibtn"
              @click="scope.row.d6 = !scope.row.d6"
              type="text"
              size="mini"
              >{{ scope.row.d6 ? "停用" : "启用" }}</el-button
            >
            <el-button
              class="minibtn"
              type="text"
              size="mini"
              @click="
                value = true;
                type = 1.5;
              "
              >编辑</el-button
            >
            <el-button class="minibtn" type="text" size="mini" @click="remove1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!--  小程序配置-->
    <el-card v-show="tabPosition == 4" class="my_card4" shadow="never">
      <div class="title">
        <p>
          <img src="../../assets/images/ticons/Slice 18@2x (3).png" alt="" />
          <span>小程序配置</span>
        </p>
        <p>
          <el-button
            class="refresh"
            plain
            round
            icon="el-icon-refresh-right"
            @click="refresh"
            >刷新列表</el-button
          >
          <el-button
            @click="
              value = true;
              type = 2;
            "
            class="addbtn"
            type="primary"
            round
            icon="el-icon-plus"
            >创建账号</el-button
          >
        </p>
      </div>
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData4"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="账号名称" width="180">
        </el-table-column>
        <el-table-column prop="d2" label="类型" width="180">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.d2 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="d3" label="APPID" width="180"> </el-table-column>
        <el-table-column prop="t4" label="创建人" width="180">
        </el-table-column>
        <el-table-column prop="d5" label="创建时间" width="180">
        </el-table-column>
        <el-table-column prop="d6" label="操作">
          <template slot-scope="scope">
            <el-switch :width="30" v-model="scope.row.d6"> </el-switch>
            <el-button
              class="minibtn"
              @click="scope.row.d6 = !scope.row.d6"
              type="text"
              size="mini"
              >{{ scope.row.d6 ? "停用" : "启用" }}</el-button
            >
            <el-button
              class="minibtn"
              type="text"
              size="mini"
              @click="
                value = true;
                type = 1.5;
              "
              >编辑</el-button
            >
            <el-button class="minibtn" type="text" size="mini" @click="remove1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 创建账号弹框组件 -->
    <eldialog v-model="value" :type="type"> </eldialog>
    <!-- 测试发送弹框 -->
    <testdialog :testDialog.sync="testDialog" :num="num"> </testdialog>
  </div>
</template>

<script>
import eldialog from "./components/dialog.vue";
import testdialog from "./components/testDialog.vue";
export default {
  components: {
    eldialog,
    testdialog,
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      //短线签名详情页面的执照点击查看数据
      showViewer: false,
      imgList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      ],
      //输入框
      value1: "",
      //上传组件
      imageUrl: "",
      imageUrl2: "",
      //绿色勾的图片地址
      imgUrl2: require("@/assets/images/ticons/time (1).png"),
      //表单数据
      form: {
        name1: "",
        name2: "",
        name3: "",
        radio: "",
      },
      formLabelWidth: "150px",
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        name2: [{ required: true, message: "请输入模板内容", trigger: "blur" }],
        name3: [{ required: true, message: "请输入申请说明", trigger: "blur" }],
         name4: [{ required: true, message: "请输入签名名称", trigger: "blur" }],
      },
      //成功或失败
      num: 1,
      //控制测试发信息弹框
      testDialog: false,
      //判断谁促发弹框
      type: 1,
      //弹框组件
      value: false,
      // 控制顶部4个按钮切换
      tabPosition: "1",
      //表格数据
      tableData: [
        {
          d1: "小橘帮帮",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: false,
        },
        {
          d1: "颐安中台",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: true,
        },
      ],
      //推送配置
      tableData2: [
        {
          d1: "小橘帮帮",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: false,
        },
        {
          d1: "颐安中台",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: false,
        },
        {
          d1: "小橘帮帮",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: false,
        },
      ],
       tableData2d5: [
        {
          d1: "小橘帮帮",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: false,
        },
        {
          d1: "颐安中台",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: false,
        },
        {
          d1: "小橘帮帮",
          d2: "吴彦祖",
          d3: "2021.07.07 18:00",
          d4: false,
        },
      ],
      tableData3: [
        {
          d1: "小橘帮帮",
          d2: "服务号",
          d3: "awx45365364647",
          t4: "吴彦祖",
          d5: "2021.07.07 18:00",
          d6: false,
        },
        {
          d1: "颐安中台",
          d2: "服务号",
          d3: "awx45365364647",
          t4: "吴彦祖",
          d5: "2021.07.07 18:00",
          d6: false,
        },
      ],
      tableData4: [
        {
          d1: "小橘帮帮-小程序",
          d2: "小程序",
          d3: "awx45365364647",
          t4: "吴彦祖",
          d5: "2021.07.07 18:00",
          d6: false,
        },
        {
          d1: "颐安中台-小程序",
          d2: "小程序",
          d3: "awx45365364647",
          t4: "吴彦祖",
          d5: "2021.07.07 18:00",
          d6: false,
        },
      ],
    };
  },
  methods: {
    //点击刷新按钮
    refresh() {
      this.$message({
        message: "刷新成功",
        type: "success",
      });
      this.$router.go(0);
    },
    //新增短信签名的上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      let types = ['image/jpg','image/jpeg', 'image/png'];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、PNG 格式!');
        return false;
      }
      if (!isLtSize) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    //新增短信签名的上传
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload2(file) {
       let types = ['image/jpg','image/jpeg', 'image/png'];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、PNG 格式!');
        return false;
      }
      if (!isLtSize) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    //短信配置的删除按钮
    remove1() {
      this.$confirm("是否确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        roundButton: true,
        type: "warning",
      }).then(() => {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    },
    //点击新增模板的插入变量
    add() {
      this.form.name2 = "${变量名}";
    },
    //点击新增模板的确认
    onAddTempYes() {
      this.$alert(
        "<img style='display:inline-block; transform: translate(-4px, 7px);' src=" +
          this.imgUrl2 +
          "><span style='font-size:12px;'>提交成功，请耐心等待审核</span> ",
        "温馨提示",
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    //点击测试发送
    ontestsend(row) {
      this.testDialog = true;
      if (!row.d4) {
        this.num = 1;
      } else {
        this.num = 2;
      }
    },
  },
  created() {},
};
</script>

<style lang='less'>
.companySet {
  padding: 20px;
  .el-radio-button:first-child .el-radio-button__inner {
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 18px 0 0 18px;
  }
  .el-radio-button .el-radio-button__inner {
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
  }
  .el-radio-button:last-child .el-radio-button__inner {
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 0 18px 18px 0;
  }
  .my_card1,
  .my_card2,
  .my_card3,
  .my_card4 {
    height: 800px;
    .el-card__body {
      padding: 0 !important;
    }
    .title {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
        span {
          margin-left: 10px;
        }
      }
      .refresh {
        border-color: #2e6cf6;
        color: #2e6cf6;
      }
    }
    .el-table {
      border: 0;
      .cell {
        text-align: center;
        font-size: 12px;
      }
      .el-table__row {
        height: 51px;
      }
      .minibtn {
        font-size: 12px;
        color: #0091ff;
      }
      .el-switch {
        margin-right: 10px;
      }
      .el-tag {
        width: 74px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
      }
    }
  }
  //模板详情样式
  .my_card1 .templateDetails {
    padding: 20px;
    h3 {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #33393f;
    }
    .d1 {
      padding-bottom: 200px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.09000000357627869);
      p {
        margin-top: 34px;
        &:nth-child(1) {
          margin-top: 57px;
        }
        .s1 {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666ff;
        }
        .s2 {
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333ff;
        }
      }
    }
    .back {
      margin-top: 10px;
    }
  }
  //新增模板样式
  .my_card1 .addTemplate {
    padding: 20px;
    h3 {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #33393f;
    }
    //表单样式
    .el-form {
      margin-top: 30px;
      margin-left: 1px;
      position: relative;
      padding-bottom: 100px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.09000000357627869);
      .el-form-item__label {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        white-space: nowrap;
      }
      .el-input__inner {
        width: 424px;
        height: 32px;
        background: #f6f6f6;
        border-radius: 16px;
      }
      .el-textarea__inner {
        width: 424px;
        height: 169px;
        background: #f6f6f6;
        border-radius: 5px;
      }
      .el-button {
        position: absolute;
        top: 127px;
        left: 304px;
        width: 114px;
        height: 36px;
        background: #2e6cf6;
        border-radius: 18px 18px 18px 18px;
      }
      .text1,
      .text2 {
        margin-top: 15px;
        width: 424px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }
      .text2 {
        margin-top: 0;
        color: #327effff;
      }
      .el-upload--picture-card {
        width: 80px;
        height: 80px;
        line-height: 80px;
      }
      .el-upload--picture-card i {
        font-size: 14px;
        color: #8c939d;
      }
    }
    .btn {
      margin-top: 10px;
      .el-button--default {
        width: 69px;
        height: 32px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
      }
      .el-button--primary {
        width: 74px;
        height: 32px;
        background: #327eff;
        border-radius: 16px 16px 16px 16px;
      }
    }
  }
  //签名详情样式
  .my_card1 .signatureDetails {
    padding: 20px;
    padding-bottom: 210px;
    h3 {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #33393f;
    }
    .d1 {
      padding-bottom: 210px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.09000000357627869);
      p {
        margin-top: 34px;
        .s1 {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666ff;
        }
        .s2 {
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333ff;
        }
        &:nth-child(1) {
          margin-top: 57px;
        }
        &:nth-child(3) {
          .s2 {
            color: #327eff;
          }
        }
        &:nth-child(5) {
          .s2 {
            color: #327eff;
          }
        }
        &:nth-child(6) {
          display: flex;
          .s2 {
            display: inline-block;
            width: 422px;
            height: 150px;
            background: #f6f6f6;
            border-radius: 4px 4px 4px 4px;
            color: #999999;
          }
        }
      }
    }
    .back {
      margin-top: 10px;
    }
  }
  //新增签名样式
  .my_card1 .addSignature {
    padding: 20px;
    h3 {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #33393f;
    }
    .p {
      margin-left: 8px;
      box-sizing: border-box;
      padding-left: 13px;
      margin-top: 38px;
      margin-bottom: 26px;
      width: 100%;
      height: 38px;
      background: rgba(73, 116, 251, 0.112516388297081);
      border-radius: 4px 4px 4px 4px;
      line-height: 38px;
      .s1 {
        color: #258ef7;
      }
      .s2 {
        margin-left: 13px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #258ef7;
      }
    }
    //表单样式
    .el-form {
      margin-top: 30px;
      margin-left: 1px;
      position: relative;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.09000000357627869);
      .el-form-item__label {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        white-space: nowrap;
      }
      .el-input__inner {
        width: 424px;
        height: 32px;
        background: #f6f6f6;
        border-radius: 16px;
      }
      .el-textarea__inner {
        width: 422px;
        height: 89px;
        background: #f6f6f6;
        border-radius: 5px;
      }
      .el-upload--picture-card {
        width: 80px;
        height: 80px;
        line-height: 80px;
      }
      .el-upload--picture-card i {
        font-size: 14px;
        color: #8c939d;
      }
      //头像上传部分
      .tips {
        margin-left: 0px;
        margin-top: 0px;
        font-size: 10px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #aab2bb;
        span {
          color: #e02020;
        }
      }
      .avatar-uploader {
        border: none;
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        background-color: #fff;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
      }
      .el-icon-plus:before {
        font-size: 14px;
        color: #d7d7d7;
      }
      .avatar {
        width: 80px;
        height: 80px;
        display: block;
      }
    }

    .btn {
      margin-top: 10px;
      .el-button--default {
        width: 69px;
        height: 32px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
      }
      .el-button--primary {
        width: 79px;
        height: 32px;
        padding: 0;
        background: #327eff;
        border-radius: 16px 16px 16px 16px;
      }
    }

    // 日期选择器组件样式
    .el-range-editor--mini.el-input__inner {
      margin-left: 150px;
      margin-top: -50px;
      margin-bottom: 20px;
      width: 200px;
      border-radius: 0;
      background-color: #fff;
    }
    .el-date-editor .el-range-separator {
      padding: 0px 4px;
      line-height: 18px;
      width: 5%;
      color: #c6c8cc;
    }
  }
}
</style>